/**
 * SEO para páginas /findyourcoliving/:provider vs /encuentratucoliving/:provider.
 * Proveedores solo-ES indexables en ruta ES; en findyourcoliving → noindex + canonical ES.
 */

'use strict';

/** Proveedores cuyo mercado principal es US o UK — indexables en /findyourcoliving */
const US_UK_PROVIDER_SLUGS = new Set([
  // US — NYC
  'junehomes', 'furnishedquarters', 'fllat', 'aya', 'cohabs', 'outpost',
  'roomrs', 'nodenyc', 'silverman', 'reserve', 'squarelivinghub', 'blueground',
  'common', 'bungalow', 'outsitenyc', 'ollie', 'sharedeasy',
  // UK — London
  'arkliving', 'gravityco', 'folkcoliving', 'masonfifth', 'cohabslondon',
  'nodelondon', 'quintainliving', 'scape', 'canvas', 'lyvly', 'fizzyliving',
  'vonder', 'chapter', 'aparto', 'yourtribe', 'uncle', 'dandi', 'iq', 'unite',
  'bloom', 'bamboo', 'stayclub', 'coluxliving', 'thecollective', 'studentroost',
  'domicoliving',
  // Multi-región — mantener EN indexable
  'outsite', 'node', 'aticco',
]);

function isUSUKProviderSlug(slug) {
  if (!slug) return false;
  return US_UK_PROVIDER_SLUGS.has(String(slug).toLowerCase());
}

/** Proveedor ES (o multi con foco ES) accedido por /findyourcoliving → consolidar en ES */
function shouldNoIndexProviderOnEnglishPath(routePath, providerSlug) {
  if (!routePath || !providerSlug) return false;
  const path = String(routePath).toLowerCase();
  if (!path.startsWith('/findyourcoliving/')) return false;
  if (path.split('/').filter(Boolean).length !== 2) return false;
  return !isUSUKProviderSlug(providerSlug);
}

function providerCanonicalOnEnglishPath(siteUrl, providerSlug) {
  if (!shouldNoIndexProviderOnEnglishPath('/findyourcoliving/x', providerSlug)) return null;
  return `${siteUrl}/encuentratucoliving/${String(providerSlug).toLowerCase()}`;
}

module.exports = {
  US_UK_PROVIDER_SLUGS,
  isUSUKProviderSlug,
  shouldNoIndexProviderOnEnglishPath,
  providerCanonicalOnEnglishPath,
};
